import React, { createContext, useContext, useState, ReactNode } from 'react';

interface ModalContextType {
  showLoginModal: boolean;
  setShowLoginModal: (show: boolean) => void;
}

const ModalContext = createContext<ModalContextType | undefined>(undefined);

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within a ModalProvider');
  }
  return context;
};

interface ModalProviderProps {
  children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [showLoginModal, setShowLoginModal] = useState(false);

  return (
    <ModalContext.Provider value={{ showLoginModal, setShowLoginModal }}>
      {children}
    </ModalContext.Provider>
  );
};

